import { render, staticRenderFns } from "./ProjectsForm.vue?vue&type=template&id=977cf8f0"
import script from "./ProjectsForm.vue?vue&type=script&lang=js"
export * from "./ProjectsForm.vue?vue&type=script&lang=js"
import style0 from "./ProjectsForm.vue?vue&type=style&index=0&id=977cf8f0&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports